import React, { useEffect, useRef,useState } from "react";
import classNames from "classnames/bind";
import PropType from "prop-types";
import styles from "./Alert.module.css";
import alert from "../../assets/images/CanhBao.png";
import success from "../../assets/images/Success.png";

const cx = classNames.bind(styles);
const Alert = ({ onClose, onOk, type = "alert", href, title, content,onCheck }) => {
  const refModal = useRef();
  const [showInput,setInput] = useState(false)
  const handleCancel = () => {
    onClose();
  };
  const handleOk = () => {
    onOk();
  };

  useEffect(() => {
    const handleCloseOnClickOutSide = (e) => {
      if (e.target === refModal.current) {
        handleCancel();
      }
    };
    document.addEventListener("click", handleCloseOnClickOutSide);
    return () => {
      document.removeEventListener("click", handleCloseOnClickOutSide);
    };
    // eslint-disable-next-line
  }, []);
  return (
    <div className={cx("content")} ref={refModal}>
      <div className={cx("container")}>
        <div className={cx("img")}>
          <img src={type === "alert" ? alert : success} alt="Ảnh cảnh báo" />
        </div>
        <div className={cx("description")}>
          <span className={cx("name")}>{title}</span>
          <span className={cx("title")}>{content}</span>
        </div>
        <div className={cx("actions")}>
          {type === "alert" ? (
            <button onClick={handleCancel} className={cx("btn", "btn-cancel")}>
              Hủy bỏ
            </button>
          ) : (
            ""
          )}
          {href ? (
            <div className={cx("connect")}>
              <a
                href={href}
                target="_blank"
                onClick={handleOk}
                className={cx("btn", "btn-accept")}
              >
                Đồng ý
              </a>
              <a
                // href={href}
                // target="_blank"
                onClick={onCheck}
                className={cx("btn", "btn-primary")}
              >
                Liên kết
              </a>
            </div>
          ) : (
            <button onClick={handleOk} className={cx("btn", "btn-accept")}>
              Đồng ý
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
Alert.propTypes = {
  onOk: PropType.func,
  onClose: PropType.func,
  type: PropType.string,
  title: PropType.string,
  content: PropType.any,
};
export default Alert;
